import requestv2 from "~/utils/http-v2";

const hostInfoApi = {
    gets : async (params) => {
        const url = 'v2/host-info';
        return await requestv2.get(url, {params});
    },
    add : async (params) => {
        const url = 'v2/host-info';
        return await requestv2.post(url, params);
    },
    update : async (params) => {
        const url = `v2/host-info/${params.id}`;
        return await requestv2.patch(url, params);
    },
    delete : async (id) => {
        const url = `v2/host-info/${id}`;
        return await requestv2.delete(url);
    },
    login : async (id) => {
        const url = `v2/host-info/login/${id}`;
        return await requestv2.post(url);
    },
    loginDb : async (id) => {
        const url = `v2/host-info/phpmyadmin/${id}`;
        return await requestv2.post(url);
    },
    ftpCreated : async (id) => {
        const url = `v2/host-info/ftp/created/${id}`;
        return await requestv2.post(url);
    },
    ftpPassword : async (params) => {
        const url = `v2/host-info/ftp/password/${params.id}`;
        return await requestv2.post(url, params);
    },
    status : async (params) => {
        const url = `v2/host-info/status/${params.id}`;
        return await requestv2.post(url, params);
    }
};

export default hostInfoApi;